import React, { PureComponent } from 'react';
import moment from 'moment';
import PropTypes from 'prop-types';
import MobileOverlay from '../common/MobileOverlay';

export default class NoSpendDataError extends PureComponent {
  static propTypes = {
    content: PropTypes.object,
    reload: PropTypes.func,
    openFaq: PropTypes.object,
  };
  totalDaysLeft = () => {
    const currentDate = moment(moment().format('DD/MM/YYYY'), 'DD/MM/YYYY');
    const lastDateOfTheMonth = moment(
      moment().endOf('month').format('DD/MM/YYYY'),
      'DD/MM/YYYY'
    );
    return lastDateOfTheMonth.diff(currentDate, 'days');
  };
  render() {
    const content = this.props.content;
    return (
      <div>
        <div className=" spending main-container">
          <div className="content-wrapper spendings-landings">
            <div className="calendar-row">
              <section className="text-center">
                <h5>
                  <span className="icon icon-calendar" />
                  {this.totalDaysLeft()} {content.spendingDaysLeftText}
                </h5>
              </section>
              <section className="text-left">
                <MobileOverlay
                  getHeaderClass={this.getHeaderClass}
                  selectedTab="nospendings"
                  content={this.props.content}
                  openFaq={this.props.openFaq}
                />
              </section>
            </div>
            <div className="sendings__noData text-center">
              <h1>
                {this.props.statusResponse === 409
                  ? content.accountStatusHeaderContent
                  : content.spendingNoSpendTitle}
              </h1>
              <p>
                {this.props.statusResponse === 409
                  ? content.accountStatusBodyContent
                  : content.spendingNoSpend}
              </p>
              <button
                className="page-options border opt-green"
                type="button"
                onClick={this.props.reload}
              >
                {this.props.statusResponse === 409
                  ? 'Retry'
                  : content.spendingTryButtonText}
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
